// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__iTx+J","content":"Overlay_content__z+kE8","spinner":"Overlay_spinner__b7XXp","spin":"Overlay_spin__AZ9QH"};